export default __webpack_public_path__ + "images/8a14ebc5a264fcca79b3e69adbf7c10c.png";